// @ts-strict-ignore
import PostListCard from 'src/modules/community/shared/components/sidebar/postListCard';
import i18n from 'src/utils/translate';

export default function PopularPosts({ posts = [] }): JSX.Element {

  if (posts.length === 0) return null;

  return (
    <PostListCard
      posts={posts}
      postType="popular-post"
      title={i18n.t('Popular Posts')}
    />
  );
}
